"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Widget initializer service.
 */
class WidgetInitializer {
    /**
     *
     * @param {WidgetInitializerPluginManager} widgetInitializerPluginManager
     */
    constructor(widgetInitializerPluginManager) {
        this.widgetInitializeManager = widgetInitializerPluginManager;
    }
    /**
     * Initializes the widget data.
     *
     * @param {WidgetConfig} config
     * @param {WidgetState} state
     * @return {Promise<*>}
     */
    initialize(config, state) {
        let promise = Promise.resolve();
        this.widgetInitializeManager.createAll().forEach((initializer) => {
            promise = promise.then(() => initializer.initialize(config, state));
        });
        return promise;
    }
}
exports.default = WidgetInitializer;
